package com.neurobs.ccabserver.subjectsessionview.components.sessionrunview.components

import com.neurobs.react.semanticui.UiMessageFactory
import slinky.core.FunctionalComponent
import slinky.core.annotations.react

@react
object RunErrorMessage {
  case class Props(error: String)
  val component = FunctionalComponent[Props] { props =>
    UiMessageFactory.BasicErrorMessage(props.error)("mini")
  }

}
